import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import PlannerHome from './components/PlannerHome';
import AssessmentInput from './components/AssessmentInput';
import CorePhonicsSurvey from './components/CorePhonicsSurvey';
import QPSSurvey from './components/QPSSurvey';
import DIBELSSurvey from './components/DIBELSSurvey';
import ThriveSurvey from './components/ThriveSurvey';
import GroupPlanner from './components/GroupPlanner';
import PlanOutput from './components/PlanOutput';
import { PlannerProvider } from './context/PlannerContext';
import './App.css';

// Component to handle route changes and update iframe height
function RouteChangeHandler() {
  const location = useLocation();

  useEffect(() => {
    // Update iframe height when route changes
    if (window.updateIframeHeight) {
      // Delay to allow React to render the new route
      setTimeout(() => window.updateIframeHeight(), 300);
    }
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <PlannerProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-purple-50/20 font-sans">
          <RouteChangeHandler />
          <Routes>
            <Route path="/" element={<PlannerHome />} />
            <Route path="/assessment" element={<AssessmentInput />} />
            <Route path="/core-survey" element={<CorePhonicsSurvey />} />
            <Route path="/qps-survey" element={<QPSSurvey />} />
            <Route path="/dibels-survey" element={<DIBELSSurvey />} />
            <Route path="/thrive-survey" element={<ThriveSurvey />} />
            <Route path="/groups" element={<GroupPlanner />} />
            <Route path="/plan" element={<PlanOutput />} />
          </Routes>
        </div>
      </Router>
    </PlannerProvider>
  );
}

export default App;